import React from 'react';
import {Outlet} from 'react-router-dom';
import RouteRedirect from '@/app/wrapper/RouteRedirect';
import {AppstoreOutlined, MessageTwoTone} from '@/icons';
import ExternalPage from '@/page/conversation/ExternalPage';
import InternalPage from '@/page/conversation/InternalPage';
import CustomerPage from '@/page/conversation/CustomerPage';
import SessionRetainedPage from '@/page/conversation/ConPage';
import AuthRoute from '@/app/AuthRoute';
import MyIcon from '@/app/MyIcon';

const converstaionMenu = {
    icon: <MessageTwoTone />,
    title: '会话管理',
    path: 'conversation',
    element: <Outlet />,
    children: [
        {
            index: true,
            element: <RouteRedirect menuKey="converstaionMenu" />,
        },
        // {
        //     label: '外部会话查询',
        //     path: 'external',
        //     icon: <MyIcon type="icon-waibuhuihuachaxun" />,
        //     authorities: ['global:conversation_out_mgr:r', 'global:conversation_out_mgr:w'],
        //     element: (
        //         <AuthRoute
        //             onAuthorities={[
        //                 'global:conversation_out_mgr:r',
        //                 'global:conversation_out_mgr:w',
        //             ]}
        //         >
        //             <ExternalPage />
        //         </AuthRoute>
        //     ),
        // },
        // {
        //     label: '内部会话查询',
        //     path: 'internal',
        //     icon: <MyIcon type="icon-neibuhuihuachaxun" />,
        //     authorities: ['global:conversation_in_mgr:r', 'global:conversation_in_mgr:w'],
        //     element: (
        //         <AuthRoute
        //             onAuthorities={['global:conversation_in_mgr:r', 'global:conversation_in_mgr:w']}
        //         >
        //             <InternalPage />
        //         </AuthRoute>
        //     ),
        // },
        // {
        //     label: '客户会话查询',
        //     path: 'customer',
        //     icon: <MyIcon type="icon-kehuhuihuachaxun" />,
        //     authorities: [
        //         'global:conversation_customer_mgr:r',
        //         'global:conversation_customer_mgr:w',
        //     ],
        //     element: (
        //         <AuthRoute
        //             onAuthorities={[
        //                 'global:conversation_customer_mgr:r',
        //                 'global:conversation_customer_mgr:w',
        //             ]}
        //         >
        //             <CustomerPage />
        //         </AuthRoute>
        //     ),
        // },
        {
            label: '高级会话查询',
            path: 'advance',
            icon: <MyIcon type="icon-gaojihuihuachaxun" />,
            authorities: ['global:conversation_ad_mgr:r', 'global:conversation_ad_mgr:w'],
            element: (
                <AuthRoute
                    onAuthorities={['global:conversation_ad_mgr:r', 'global:conversation_ad_mgr:w']}
                >
                    <SessionRetainedPage />
                </AuthRoute>
            ),
        },
    ],
};

export default converstaionMenu;
